import {
    setSelectedOrder,
    setEnableOrderTracking,
    setEnableDropshipFlag,
    setReturnableFlag,
    setEnablePartOrdering
} from './actions';

 
const dispatchSelectedOrder = (dispatch:any) => (param:any) =>{
    dispatch(setSelectedOrder(param));
}

const dispatchEnableOrderTracking = (dispatch: any) => (param: any) => {
    dispatch(setEnableOrderTracking(param));
}

const dispatchEnableDropshipFlag = (dispatch: any) => (param: any) => {
    dispatch(setEnableDropshipFlag(param));
}

const dispatchReturnableFlag = (dispatch: any) => (param: any) => {
    dispatch(setReturnableFlag(param));
}

const dispatchEnablePartOrdering = (dispatch: any) => (param: any) => {
    dispatch(setEnablePartOrdering(param));
}
 
const operations = {
    dispatchSelectedOrder,
    dispatchEnableOrderTracking,
    dispatchEnableDropshipFlag,
    dispatchReturnableFlag,
    dispatchEnablePartOrdering
};

export default operations;
